import { render, staticRenderFns } from "./ProposalProductFilters.vue?vue&type=template&id=1f77e1a4"
import script from "./ProposalProductFilters.vue?vue&type=script&lang=js"
export * from "./ProposalProductFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports